// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img-sample {
    height: 300px;
    margin-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/Image.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".img-sample {\n    height: 300px;\n    margin-bottom: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
